import { RenderContext3D } from "../RenderContext3D";
import { RenderElement } from "../RenderElement";
import { Command } from "./Command";
import { Vector4 } from "../../../../maths/Vector4";
import { Laya3DRender } from "../../../RenderObjs/Laya3DRender";
import { Viewport } from "../../../../maths/Viewport";
import { ScreenQuad } from "./geometry/ScreenQuad";
import { LayaGL } from "../../../../layagl/LayaGL";
import { Pool } from "../../../../utils/Pool";
const _defaultOffsetScale = new Vector4(0, 0, 1, 1);
export class BlitScreenQuadCMD extends Command {
    static create(source, dest, offsetScale = null, shader = null, shaderData = null, subShader = 0, screenType = BlitScreenQuadCMD.SCREENTYPE_QUAD, commandbuffer = null) {
        let cmd = BlitScreenQuadCMD._pool.take();
        cmd._source = source;
        cmd.dest = dest;
        cmd.offsetScale = offsetScale || _defaultOffsetScale;
        cmd.setshader(shader, subShader, shaderData);
        cmd._commandBuffer = commandbuffer;
        return cmd;
    }
    constructor() {
        super();
        this._source = null;
        this._dest = null;
        this._offsetScale = new Vector4();
        this._shader = null;
        this._shaderData = null;
        this._internalShaderData = null;
        this._subShader = 0;
        this._blitQuadCMDData = Laya3DRender.Render3DPassFactory.createBlitQuadCMDData();
        this._transform3D = Laya3DRender.Render3DModuleDataFactory.createTransform(null);
        this._renderElement = new RenderElement();
        this._renderElement.setTransform(this._transform3D);
        this._renderElement.setGeometry(ScreenQuad.instance);
        this._blitQuadCMDData.element = this._renderElement._renderElementOBJ;
        this._blitQuadCMDData.element.isRender = true;
    }
    get offsetScale() {
        return this._offsetScale;
    }
    set offsetScale(value) {
        value.cloneTo(this._offsetScale);
        this._blitQuadCMDData.offsetScale = value;
    }
    get dest() {
        return this._dest;
    }
    set dest(value) {
        this._dest = value;
        this._blitQuadCMDData.dest = value ? value._renderTarget : null;
    }
    set shaderData(value) {
        if (value) {
            this._shaderData = value;
        }
        else {
            if (!this._internalShaderData)
                this._internalShaderData = LayaGL.renderDeviceFactory.createShaderData();
            this._internalShaderData.clearData();
            this._shaderData = this._internalShaderData;
        }
        this._renderElement._renderElementOBJ.materialShaderData = this._shaderData;
    }
    getRenderCMD() {
        return this._blitQuadCMDData;
    }
    setshader(shader, subShader, shaderData) {
        this._shader = shader || Command._screenShader;
        this._subShader = subShader || 0;
        this.shaderData = shaderData;
        this._renderElement.renderSubShader = this._shader.getSubShaderAt(this._subShader);
        this._renderElement._subShaderIndex = subShader;
    }
    run() {
        var source;
        if (!this._source) {
            if (!this._commandBuffer._camera._internalRenderTexture)
                throw "camera internalRenderTexture is null,please set camera enableBuiltInRenderTexture";
            source = this._commandBuffer._camera._internalRenderTexture;
        }
        else
            source = this._source;
        this._blitQuadCMDData.source = source._texture;
        var dest = this._dest ? this._dest : this._commandBuffer._camera._internalRenderTexture;
        if (dest != this._dest)
            this._blitQuadCMDData.dest = dest._renderTarget;
        if (dest) {
            Viewport.TEMP.set(0, 0, dest.width, dest.height);
            Vector4.TEMP.setValue(0, 0, dest.width, dest.height);
            this._blitQuadCMDData.viewport = Viewport.TEMP;
            this._blitQuadCMDData.scissor = Vector4.TEMP;
        }
        else {
            let camera = this._commandBuffer._camera;
            let viewport = camera.viewport;
            let vpH = viewport.height;
            let vpY = RenderContext3D.clientHeight - viewport.y - vpH;
            Viewport.TEMP.set(viewport.x, vpY, viewport.width, vpH);
            Vector4.TEMP.setValue(viewport.x, vpY, viewport.width, vpH);
            this._blitQuadCMDData.viewport = Viewport.TEMP;
            this._blitQuadCMDData.scissor = Vector4.TEMP;
        }
        let invertY = dest ? true : false;
        if (LayaGL.renderEngine._screenInvertY) {
            if (invertY && dest._isCameraTarget) {
                invertY = false;
            }
        }
        this._renderElement.setGeometry(invertY ? ScreenQuad.InvertInstance : ScreenQuad.instance);
    }
    recover() {
        BlitScreenQuadCMD._pool.recover(this);
        this._source = null;
        this._dest = null;
        _defaultOffsetScale.cloneTo(this._offsetScale);
        this._shader = null;
        this._shaderData = null;
        super.recover();
    }
    destroy() {
        this._source = null;
        this.dest = null;
        this._offsetScale = null;
        this._shader = null;
        this._shaderData = null;
        if (this._internalShaderData)
            this._internalShaderData.destroy();
        this._internalShaderData = null;
        this._renderElement.destroy();
    }
}
BlitScreenQuadCMD.SCREENTYPE_QUAD = 0;
BlitScreenQuadCMD.SCREENTYPE_TRIANGLE = 1;
BlitScreenQuadCMD._pool = Pool.createPool(BlitScreenQuadCMD);
